import { GET_SERVICIOS_ALUMNOS_LIST } from "./ServiciosAlumnoAction";

let initialState = {
    getServiciosAlumnoList:           false,
    errorServiciosAlumnoList:         false,
};

const ServiciosAlumnoReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_SERVICIOS_ALUMNOS_LIST:
            return {
                ...state,
                getServiciosAlumnoList: action.payload.data,
                errorServiciosAlumnoList: action.payload.errorMessage,
            };

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default ServiciosAlumnoReducer;